import { useEffect, useState } from 'react';
import { ArrowRight, Menu, Search } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { Logo } from './Brand';
import { BRAND_SHORT_NAME } from '../data/brand';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from './ui/dialog';

export { Logo } from './Brand';

export const Nav = ({ onPlan, onSearch }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const update = () => setScrolled(window.scrollY > 40);
    update();
    window.addEventListener('scroll', update, { passive: true });
    return () => window.removeEventListener('scroll', update);
  }, []);

  return (
    <>
      <header className={`site-header ${scrolled ? 'is-scrolled' : ''}`} data-testid="site-header">
        <div className="nav-inner">
          <Link to="/" aria-label="Giraffe Entertainment & Experiences home" className="nav-logo-link">
            <Logo />
          </Link>

          <nav className="desktop-nav" aria-label="Main navigation">
            <Link to="/" className={location.pathname === '/' ? 'is-active' : ''} data-testid="nav-link-home">Home</Link>
            <Link to="/about-us" className={location.pathname === '/about-us' ? 'is-active' : ''} data-testid="nav-link-about">About Us</Link>
            {isHome ? (
              <a href="#experiences" data-testid="nav-link-experiences">Experiences</a>
            ) : (
              <Link to="/#experiences" data-testid="nav-link-experiences">Experiences</Link>
            )}
            {isHome ? (
              <a href="#what-we-do" data-testid="nav-link-what-we-do">What We Do</a>
            ) : (
              <Link to="/#what-we-do" data-testid="nav-link-what-we-do">What We Do</Link>
            )}
            <Link to="/contact-us" className={location.pathname === '/contact-us' ? 'is-active' : ''} data-testid="nav-link-contact">Contact Us</Link>
          </nav>

          <div className="nav-actions">
            <button className="icon-button" onClick={onSearch} aria-label="Search GEE experiences and services" title="Search" data-testid="nav-search-button">
              <Search size={20} strokeWidth={1.5} />
            </button>
            <a className="button button-gold nav-plan" href="https://guptarghat.com" target="_blank" rel="noopener noreferrer" data-testid="nav-cta-plan">
              Ayodhya <ArrowRight size={17} />
            </a>
            <button className="icon-button menu-toggle" onClick={() => setOpen(true)} aria-label="Open menu" aria-expanded={open} data-testid="nav-menu-button">
              <Menu size={24} />
            </button>
          </div>
        </div>
      </header>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="mobile-menu-panel" data-testid="mobile-menu" closeTestId="mobile-menu-close">
          <DialogTitle className="sr-only">Explore {BRAND_SHORT_NAME}</DialogTitle>
          <DialogDescription className="sr-only">Navigation Menu</DialogDescription>
          <Link to="/" onClick={() => setOpen(false)}>
            <Logo id="mobile-brand-logo" />
          </Link>

          <nav aria-label="Mobile navigation" className="mobile-nav">
            <Link to="/" onClick={() => setOpen(false)} data-testid="mobile-nav-link-home">
              Home <ArrowRight size={18} />
            </Link>
            <Link to="/about-us" onClick={() => setOpen(false)} data-testid="mobile-nav-link-about">
              About Us <ArrowRight size={18} />
            </Link>
            <a href="/#experiences" onClick={() => setOpen(false)} data-testid="mobile-nav-link-experiences">
              Experiences <ArrowRight size={18} />
            </a>
            <a href="/#what-we-do" onClick={() => setOpen(false)} data-testid="mobile-nav-link-what-we-do">
              What We Do <ArrowRight size={18} />
            </a>
            <Link to="/contact-us" onClick={() => setOpen(false)} data-testid="mobile-nav-link-contact">
              Contact Us <ArrowRight size={18} />
            </Link>

            <div className="mobile-nav-divider" />
            <Link to="/terms-and-conditions" onClick={() => setOpen(false)} className="mobile-nav-sub">
              Terms &amp; Conditions
            </Link>
            <Link to="/privacy-policy" onClick={() => setOpen(false)} className="mobile-nav-sub">
              Privacy Policy
            </Link>
            <Link to="/refund-and-cancellation" onClick={() => setOpen(false)} className="mobile-nav-sub">
              Refund &amp; Cancellation
            </Link>
          </nav>

          <a className="button button-gold" href="https://guptarghat.com" target="_blank" rel="noopener noreferrer" data-testid="mobile-nav-cta-plan">
            Ayodhya <ArrowRight size={17} />
          </a>
        </DialogContent>
      </Dialog>
    </>
  );
};